var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name == 'Login')?_c('admin',[_c('router-view')],1):_c('layout',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }